import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { FormHelperText } from "@mui/material";
import PropTypes from "prop-types";

export default function RowRadioButtonsGroup({ handleChangeRadio, value, radioError }) {
  return (
    <FormControl>
      <FormLabel id="lesson-status-label" sx={{ fontSize: "1em" }}>
        Status
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="lesson-status-label"
        name="status"
        value={value}
        onChange={handleChangeRadio}
      >
        <FormControlLabel
          value="Brouillon"
          control={<Radio />}
          label="Brouillon"
          sx={{ fontSize: "1em" }}
        />
        <FormControlLabel
          value="A valider"
          control={<Radio />}
          label="A valider"
          sx={{ fontSize: "1em" }}
        />
      </RadioGroup>
      {radioError && <FormHelperText>{radioError}</FormHelperText>}
    </FormControl>
  );
}
RowRadioButtonsGroup.propTypes = {
  value: PropTypes.string.isRequired,
  radioError: PropTypes.string.isRequired,
  handleChangeRadio: PropTypes.func.isRequired,
};
